import React, { useState, useEffect } from 'react';
import './HomePage.css';
import Column from '../../components/Layouts/Column';
import SopoLogo from '../../assets/icons/sopoLogo.png';
import Divider from '../../assets/icons/divider.png';
import AppStore from '../../assets/icons/app-store.png';
import GooglePlay from '../../assets/icons/google-play.png';
import BannerImage from '../../assets/images/home/bannerImage.png';
import MobileBannerImage from '../../assets/images/home/mobileBannerImage.png';
import { useNavigate } from 'react-router-dom';
import { getPlatformName } from '../../utils/platform.js';

const HomePage = () => {
  const [mobile, setmobile] = useState(false);
  const platformName = getPlatformName().toUpperCase();

  const navigate = useNavigate();

  useEffect(() => {
    if (window.innerWidth < 885) {
      setmobile(true);
    }
  }, []);

  return (
    <div className="homepage-container">
      {!mobile && (
        <div className="play-now-btn-container">
          <div className="play-now-btn" onClick={() => window.open("https://app.playsopo.com/link/open")}>PLAY NOW IN BROWSER</div>
        </div>
      )}
      <div className="row homepage-row">
        {!mobile ? (
          <>
            <div className='home-column left'>
              <div>
                <img src={SopoLogo} alt="sopoLogo" />
              </div>
              <div>
                <img src={Divider} alt="divider" />
              </div>
              <div className="home-description">
                <p>No Purchase Necessary | Certified Fair | Industry Leading</p>
                <p className="bold-text">READY FOR THE FUTURE</p>
              </div>
              <div className="play-now-btn play-now-btn-home" onClick={() => navigate('download-information')}>DOWNLOAD FOR {platformName}</div>
              <div className="store-icons">
                <img onClick={() => window.open(process.env.REACT_APP_IOS_STORE_URL)} src={AppStore} alt="store-icons" />
                <img onClick={() => window.open(process.env.REACT_APP_ANDROID_STORE_URL)} src={GooglePlay} alt="google-play-icons" />
              </div>
            </div>
            <div className='home-column right'>
              <div>
                <img src={BannerImage} alt="bannerImage" />
              </div>
            </div>
          </>) : (
          <>
            <Column>
              <div>
                <img src={SopoLogo} alt="sopoLogo" />
              </div>
              <div>
                <img src={Divider} alt="divider" />
              </div>
              <div className="home-description mobile">
                <p>No Purchase Necessary | Certified Fair | Industry Leading</p>
                <p className="bold-text">READY FOR THE FUTURE</p>
              </div>
              {/* <div className="play-now-btn play-now-btn-home" onClick={()=>window.open("https://app.playsopo.com/link/open")}>PLAY NOW IN BROWSER</div> */}
            </Column>
            <Column>
              <div className="mobile-banner">
                <img src={MobileBannerImage} alt="bannerImage" />
              </div>
            </Column>
            <Column>
              <div className="store-icons">
                <img onClick={() => window.open(process.env.REACT_APP_IOS_STORE_URL)} src={AppStore} alt="store-icons" />
                <img onClick={() => window.open(process.env.REACT_APP_ANDROID_STORE_URL)} src={GooglePlay} alt="google-play-icons" />
              </div>
            </Column>
          </>
        )}
      </div>
    </div>
  );
};

export default HomePage;
